import React from 'react';
import { CheckIcon, GlobeIcon, UsersIcon } from 'lucide-react';
import { Section } from '../Section';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
const stack = [{
  icon: '📘',
  title: 'Oclusion Clinical Playbook™',
  detail: '6 Professional Playbooks',
  value: '$97'
}, {
  icon: '🎁',
  title: '5 Professional Bonuses',
  detail: 'Red Flags, VDO Master Map, Case Lab, Quick Cards, Pre-Treatment Audit',
  value: '$197'
}, {
  icon: '📋',
  title: '30+ Clinical Tools',
  detail: 'Protocols, checklists, decision maps, matrices and planning worksheets',
  value: '$97'
}];
const includes = ['Instant digital access', 'Lifetime access', 'No monthly subscription', '6 Professional Playbooks', '5 Exclusive Bonuses', '30+ Clinical Tools', '7-Day Guarantee'];
export function Offer() {
  return <Section tone="dark" id="offer" data-id="element-219" data-mp="1pdq93f6eabb">
      <header className="mx-auto max-w-3xl text-center" data-id="element-220" data-mp="1qf1p903sytk">
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gold-500 sm:text-xs" data-id="element-221" data-mp="1kl88st2p7997">
          🏆 The complete Dr. Karito clinical system
        </p>
        <h2 className="mt-3 font-display text-[26px] font-bold leading-[1.15] text-white sm:text-4xl" data-id="element-222" data-mp="1fl2cv0peb0lb">
          Here’s everything you get today
        </h2>
        <div className="gold-rule mx-auto mt-5 h-px w-28" data-id="element-223" data-mp="16mgylhqyi7qc" />
      </header>

      <div className="mx-auto mt-9 w-full max-w-2xl overflow-hidden rounded-2xl border border-gold-500/35 bg-navy-950" data-id="element-224" data-mp="23bpyspw5bqqv">
        <ul className="divide-y divide-white/10" data-id="element-225" data-mp="1za4ckdxq2040">
          {stack.map(item => <li key={item.title} className="flex items-start gap-3 p-4 sm:p-5" data-id="element-226" data-mp="1uj4hle85xs45">
              <span className="text-xl" aria-hidden="true" data-id="element-227" data-mp="1pkkuvblqwcaq">
                {item.icon}
              </span>
              <div className="min-w-0 flex-1" data-id="element-228" data-mp="2mzoyn5p69dhi">
                <p className="text-[15px] font-bold leading-snug text-white" data-id="element-229" data-mp="2n1i62n7m01qk">{item.title}</p>
                <p className="mt-0.5 text-[13px] leading-snug text-slate-400" data-id="element-230" data-mp="2i8gp89nuds4c">{item.detail}</p>
              </div>
              <span className="shrink-0 text-sm font-bold text-slate-400 line-through" data-id="element-231" data-mp="31692fn6ibrnh">
                {item.value}
              </span>
            </li>)}
        </ul>

        <div className="flex items-center justify-between border-t border-gold-500/25 bg-navy-900 px-4 py-3.5 sm:px-5" data-id="element-232" data-mp="2scdw4btnfv69">
          <span className="text-[12px] font-bold uppercase tracking-[0.16em] text-slate-300" data-id="element-233" data-mp="2wcxt9fe82yse">
            Total value
          </span>
          <span className="font-display text-xl font-bold text-slate-400 line-through" data-id="element-234" data-mp="2ne2j5s8254jt">$391</span>
        </div>

        <div className="px-5 py-7 text-center sm:px-8" data-id="element-235" data-mp="29et6h2j28skl">
          <p className="text-[12px] font-bold uppercase tracking-[0.16em] text-gold-500" data-id="element-236" data-mp="29g4c77w2gaec">
            Today you get everything for just
          </p>
          <p className="mt-2 font-display text-6xl font-bold leading-none text-white sm:text-7xl" data-id="element-237" data-mp="7moig24omff5">
            $27
          </p>
          <p className="mt-2 text-[12px] font-bold uppercase tracking-[0.2em] text-slate-300" data-id="element-238" data-mp="bnzz3i5kvqb7">
            One-time payment
          </p>

          <ul className="mx-auto mt-6 grid max-w-md gap-2 text-left" data-id="element-239" data-mp="1s4z0tsics1fs">
            {includes.map(item => <li key={item} className="flex items-center gap-2.5 text-[14px] text-slate-200" data-id="element-240" data-mp="25w3tganaztgm">
                <CheckIcon className="h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-241" data-mp="215ncwho6rrq1" />
                {item}
              </li>)}
          </ul>

          <div className="mt-7" data-id="element-242" data-mp="2fsqdwybpwii4">
            <CtaButton label="Get the Oclusion Clinical Playbook™" subLabel="One payment of $27 · Instant access · Lifetime reference" data-id="element-243" data-mp="2avgo3hkf24tr" />
          </div>

          <div className="mt-6" data-id="element-244" data-mp="2jw558l53wlav">
            <CountdownTimer data-id="element-245" data-mp="2jvwouj9ryxux" />
          </div>

          <ScarcityBar data-id="element-246" data-mp="2ju24b62f17rd" />

          <p className="mt-6 flex items-center justify-center gap-2 text-[13px] leading-snug text-slate-400" data-id="element-247" data-mp="ugynmxrvless">
            <GlobeIcon className="h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-248" data-mp="pind0ktrb09i" />
            <span data-id="element-249" data-mp="rx2c0kbs47l3">
              Currency is converted <strong className="text-slate-200" data-id="element-250" data-mp="rw0pnjpbbyo2">automatically</strong> — you
              pay the $27 equivalent in your local currency.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}
function ScarcityBar() {
  return <div className="mt-7 rounded-xl border border-red-500/30 bg-red-950/25 p-4" data-id="element-251" data-mp="15wjs8bb0eciu">
      <div className="flex items-center justify-between gap-3" data-id="element-252" data-mp="15uh3dullepfp">
        <span className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide text-red-300" data-id="element-253" data-mp="8a4b5amhvgvt">
          <UsersIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-254" data-mp="d8fk7j4ytncz" />
          Promotional spots
        </span>
        <span className="text-[12px] font-bold uppercase tracking-wide text-white" data-id="element-255" data-mp="i4w9whrtc9s6">
          17 of 200 left
        </span>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-navy-950" role="progressbar" aria-valuenow={92} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-256" data-mp="3lnz9k72imlmr">
        <div className="h-full w-[92%] rounded-full bg-red-500" data-id="element-257" data-mp="3j2rn59uk36eg" />
      </div>
      <p className="mt-2.5 text-[12px] leading-snug text-red-200" data-id="element-258" data-mp="3e588i8ty4rlz">
        92% claimed. Once the remaining spots are taken, the $27 promotional price closes.
      </p>
    </div>;
}